<div class="w-full flex flex-col gap-16 md:gap-28">
  <!-- Sección de la cabecera. -->
  <section class="mt-16 md:mt-28 flex flex-col gap-4">
    <h1 class="text-4xl font-medium md:text-5xl">Activaciones</h1>
    <p class="text-lg md:text-xl">Consulta y envía activaciones al Dansap.</p>
  </section>

  <!-- Sección del cuerpo. -->
  <section class="flex flex-col gap-10">
    <div
      class="flex flex-col md:flex-row md:justify-between md:flex-wrap gap-5"
    >
      <div class="flex flex-col md:flex-row gap-5">
        <button
          mat-raised-button
          aria-hidden="false"
          aria-label="Actualizar"
          (click)="reload()"
          [disabled]="loadingActivations || loadingSendDansap"
        >
          <mat-icon>refresh</mat-icon>
          <span>Actualizar</span>
        </button>
        <button
          mat-flat-button
          aria-hidden="false"
          aria-label="Enviar al Dansap"
          (click)="sendDansap()"
          [disabled]="
            loadingActivations || !tableData.data.length || loadingSendDansap
          "
        >
          <mat-icon>send</mat-icon>
          <span class="text-nowrap">Enviar al Dansap</span>
        </button>
      </div>
      <div class="flex flex-col md:flex-row gap-5">
        @if(showFilters) {
        <button
          mat-raised-button
          aria-label="Esconder filtros"
          (click)="showFilters = !showFilters"
        >
          <mat-icon> filter_alt_off </mat-icon>
          <span class="text-nowrap">Esconder filtros</span>
        </button>
        } @else {
        <button
          mat-raised-button
          aria-label="Mostrar filtros"
          (click)="showFilters = !showFilters"
        >
          <mat-icon> filter_alt </mat-icon>
          <span class="text-nowrap">Mostrar filtros</span>
        </button>
        }
      </div>
    </div>

    @if (showFilters) {
    <!-- Filtros. -->
    <form
      class="flex flex-col md:flex-row md:items-center md:flex-wrap gap-5"
      [formGroup]="form"
      (ngSubmit)="filter()"
    >
      <mat-form-field class="w-full md:w-[180px]">
        <mat-label>Número de serie</mat-label>
        <input matInput name="serial" formControlName="serial" />
      </mat-form-field>
      <mat-form-field class="w-full md:w-[250px]">
        <mat-label>Producto</mat-label>
        <input matInput name="productName" formControlName="productName" />
      </mat-form-field>
      <mat-form-field class="w-full md:w-[250px]">
        <mat-label>Licencia</mat-label>
        <input matInput name="licenseName" formControlName="licenseName" />
      </mat-form-field>
      <mat-form-field class="w-full md:w-[150px]">
        <mat-label>Host</mat-label>
        <input matInput name="hostName" formControlName="hostName" />
      </mat-form-field>
      <mat-form-field class="w-full md:w-[250px]">
        <mat-label>Cliente</mat-label>
        <input matInput name="customerName" formControlName="customerName" />
      </mat-form-field>
      <mat-form-field class="w-full md:w-[250px]">
        <mat-label>Empleado</mat-label>
        <input
          matInput
          name="employeeDisplayName"
          formControlName="employeeDisplayName"
        />
      </mat-form-field>
      <mat-form-field class="w-full md:w-[200px]">
        <mat-label>Fecha de inicio</mat-label>
        <input
          matInput
          [matDatepicker]="filterPicker1"
          name="startDate"
          formControlName="startDate"
          placeholder="dd/mm/aaaa"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="filterPicker1"
        ></mat-datepicker-toggle>
        <mat-datepicker #filterPicker1></mat-datepicker>
      </mat-form-field>
      <mat-form-field class="w-full md:w-[200px]">
        <mat-label>Fecha de final</mat-label>
        <input
          matInput
          [matDatepicker]="filterPicker2"
          name="endDate"
          formControlName="endDate"
          placeholder="dd/mm/aaaa"
        />
        <mat-datepicker-toggle
          matIconSuffix
          [for]="filterPicker2"
        ></mat-datepicker-toggle>
        <mat-datepicker #filterPicker2></mat-datepicker>
      </mat-form-field>
      <button mat-flat-button aria-hidden="false" aria-label="Filtrar">
        <span class="text-nowrap">Filtrar</span>
      </button>
    </form>
    }

    <div class="overflow-x-auto">
      <table
        mat-table
        [dataSource]="tableData"
        matSort
        class="mat-elevation-z8"
      >
        <ng-container matColumnDef="selected">
          <th mat-header-cell *matHeaderCellDef>
            <mat-checkbox
              (change)="toggleCheckboxes($event.checked)"
            ></mat-checkbox>
          </th>
          <td mat-cell *matCellDef="let activation">
            <mat-checkbox
              (change)="activation.selected = !activation.selected"
              [checked]="activation.selected"
            ></mat-checkbox>
          </td>
        </ng-container>
        <ng-container matColumnDef="serial">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por número de serie"
          >
            Número de serie
          </th>
          <td mat-cell *matCellDef="let activation">
            {{ activation.serial }}
          </td>
        </ng-container>
        <ng-container matColumnDef="product.name">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por producto"
          >
            Producto
          </th>
          <td mat-cell *matCellDef="let activation">
            {{ activation.license.product.name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="license.name">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por licencia"
          >
            Licencia
          </th>
          <td mat-cell *matCellDef="let activation">
            {{ activation.license.name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="host.name">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por host"
          >
            Host
          </th>
          <td mat-cell *matCellDef="let activation">
            {{ activation.host.name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="customer.name">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por cliente"
          >
            Cliente
          </th>
          <td mat-cell *matCellDef="let activation">
            {{ activation.customer.name }}
          </td>
        </ng-container>
        <ng-container matColumnDef="comment">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por comentario"
          >
            Comentario
          </th>
          <td mat-cell *matCellDef="let activation">
            {{ activation.comment }}
          </td>
        </ng-container>
        <ng-container matColumnDef="employee.displayName">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por empleado"
          >
            Empleado
          </th>
          <td mat-cell *matCellDef="let activation">
            {{ activation.employee.displayName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="sent">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por estado"
          >
            Dansap
          </th>
          <td mat-cell *matCellDef="let activation">
            @if (activation.sent) {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 -960 960 960"
              class="fill-green-600 size-6"
            >
              <path
                d="m424-296 282-282-56-56-226 226-114-114-56 56 170 170Zm56 216q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
              />
            </svg>
            } @else {
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 -960 960 960"
              class="fill-red-500 size-6"
            >
              <path
                d="m336-280 144-144 144 144 56-56-144-144 144-144-56-56-144 144-144-144-56 56 144 144-144 144 56 56ZM480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T880-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm0-80q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
              />
            </svg>
            }
          </td>
        </ng-container>
        <ng-container matColumnDef="createdAt">
          <th
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            sortActionDescription="Ordenar por fecha"
          >
            Fecha
          </th>
          <td mat-cell *matCellDef="let activation">
            {{ activation.createdAt | date : "d MMM, y, H:mm" }}
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: tableColumns"></tr>
        <tr class="mat-row" *matNoDataRow>
          <td colspan="9" class="mat-cell py-5 text-gray-500 text-center">
            No hay activaciones
          </td>
        </tr>
      </table>
    </div>

    <mat-paginator
      [pageSizeOptions]="[5, 10, 20, 50]"
      showFirstLastButtons
      aria-label="Selecciona la página"
    >
    </mat-paginator>
  </section>
</div>
